import clsx from 'clsx';
import React from 'react';

const loaderSizes = {
    sm: 'w-2 h-2',
    md: 'w-4 h-4',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
}

const loaderColors = {
    blue: 'bg-blue-400',
    slate: 'bg-slate-400',
    white: 'bg-white',
    black: 'bg-black',
}

interface LoaderProps {
    loaderSize?: keyof typeof loaderSizes;
    loaderColor?: keyof typeof loaderColors;
    className?: string;
}

export const Loader: React.FC<LoaderProps> = (props) => {
    const { loaderSize = 'md', loaderColor = 'slate', className } = props

    return (
        <div
            className={clsx(
                "flex justify-center gap-2",
                className
            )}
        >
            <div className={clsx(loaderSizes[loaderSize], loaderColors[loaderColor], "rounded-full animate-bounce [animation-delay:.5s]")}></div>
            <div className={clsx(loaderSizes[loaderSize], loaderColors[loaderColor], "rounded-full animate-bounce [animation-delay:.25s]")}></div>
            <div className={clsx(loaderSizes[loaderSize], loaderColors[loaderColor], "rounded-full animate-bounce [animation-delay:.5s]")}></div>
        </div>
    )
}

export const WrappedLoader: React.FC<LoaderProps> = (props) => {
    return (
        <div className="flex justify-center items-center min-h-32">
            <Loader {...props} />
        </div>
    )
}